import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlug, faPlus } from "@fortawesome/free-solid-svg-icons";
import { IPaginated } from "src/types/paginated";
import {
  IPharmaInventory,
  IPharmaInventoryCreate,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import QueryString from "qs";
import defaultImage from "src/assets/images/emty-img.png";
import { Loader } from "lucide-react";
import { CURRENCY } from "src/lib/constans";

const PrintProduct = ({ product, index }: { product: any; index: number }) => {
  return (
    <div className="w-full flex gap-2">
      <div className="w-[70px] h-[60px] overflow-hidden rounded-lg border border-gray-300">
        <img
          src={`${product?.images}`}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-2 justify-center w-[calc(100%-80px)]">
        <p className="font-Poppins-Regular truncate font-size-16px theme-color-green">
          {product?.productName}
        </p>
        <div className="font-Poppins-Medium flex justify-between -mt-[5px] font-size-14px theme-color-gray">
          <p>{CURRENCY} {parseFloat(product?.salePrice ? product?.salePrice : product?.regularPrice || "0").toFixed(2)}</p>
          <p>Quantity: {product?.quantity > 0 ? String(product?.quantity).padStart(2, "0") : "0"}</p>
        </div>
      </div>
    </div>
  );
};

interface IResponce {
  documents: IPharmaInventory[];
  paginated: IPaginated;
}

const InventoryFrequenltyBoughtTab = ({
  state,
  setState,
  tabChange,
  setLocalProduct,
  localProduct,
}: {
  state: IPharmaInventoryCreate;
  setState: (
    key: keyof IPharmaInventoryCreate,
    val: string | string[] | { [key: string]: any }
  ) => void;
  tabChange: () => void;
  setLocalProduct: (data: IPharmaInventory) => void;
  localProduct: IPharmaInventory[];
}) => {
  const [search, setSearch] = useState("");
  // All Products
  const [allProducts, setAllProducts] = useState<IPharmaInventory[]>([]);
  const [productLoader, setProductLoader] = useState(false);

  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });

  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    searchProduct: "",
    bool: false,
    searchBrand: "",
    searchCategory: "",
  });

  const handleChangeText = (txt: string) => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      searchProduct: txt,
    }));
  };

  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const fetchAllProducts = async () => {
    setProductLoader(true);
    const { bool, ...remainingParams } = queryParams;
    const { res, err } = await httpRequest<IResponce>({
      path: `/pharma-inventory/getAll?${QueryString.stringify(
        remainingParams
      )}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setAllProducts(documents);
      setLocalProduct(documents as any);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setProductLoader(false);
  };

  useEffect(() => {
    fetchAllProducts();
  }, [queryParams]);

  return (
    <>
      <div className="w-full flex gap-2 border-b border-gray-300 mb-5 pb-5">
        <div className="w-full bg-[#F6FBFF] rounded-lg p-3 h-[430px] overflow-y-auto">
          <h2 className="font-Poppins-SemiBold font-size-20px mb-2 text-[#4F6367]">
            Frequently Bought Together
          </h2>
          <div className="flex flex-col gap-4">
            {productLoader ? (
              <div className="w-full h-40 flex items-center justify-center gap-2">
                <Loader className="animate-spin" /> Loading Products...
              </div>
            ) : state.frequentlyBoughtTogether.length > 0 ? (
              state.frequentlyBoughtTogether.map(
                (productID: any, index: number) => (
                  <PrintProduct product={localProduct.find((product) => product._id === productID)} index={index} />
                )
              )
            ) : (
              <div className="w-full h-[100px] flex items-center justify-center">
                <p className="font-Poppins-Regular font-size-16px theme-color-gray">
                  No products added
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-full">
        <SearchFilterInput
          key={"search"}
          inputExtraStyle={{ marginBottom: 0 }}
          onChangeText={handleChangeText}
          searchVal={queryParams?.searchProduct}
          containerExtraStyle={{
            justifyContent: "flex-start",
          }}
        />
        <div className="w-full mt-5">
          <TableWrapper
            isLoading={productLoader}
            thead={["S.No", "Product Image", "Product Name", "Action"]}
            page={queryParams.page}
            total={paginated.totalPages}
            columnWidth={"6% 19% 65% 10%"}
            onChange={handlePageChange}
            totalLength={allProducts.length}
          >
            <div className="tbody-content-height tbody-content-height-allOrder">
              {allProducts?.map((item: IPharmaInventory, index: number) => (
                <ul
                  key={index}
                  className={`font-size-16px tbody-light-table font-Poppins-Regular grid`}
                  style={{
                    gridTemplateColumns: "6% 19% 65% 10%",
                  }}
                >
                  <li>{index + 1}</li>
                  <li>
                    <img
                      src={`${item?.images}`}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.src = defaultImage;
                      }}
                      className="w-[30px] h-[30px] object-cover"
                    />
                  </li>
                  <li className="capitalize">{`${item?.productName || ""}`}</li>
                  <li>
                    <div
                      className="w-[23px] cursor-pointer h-[23px] border border-gray-600 rounded flex items-center justify-center"
                      onClick={() => {
                        let isExist = state.frequentlyBoughtTogether.find(
                          (productID: any) => productID === item._id
                        );

                        if (isExist) {
                          setState(
                            "frequentlyBoughtTogether",
                            state.frequentlyBoughtTogether.filter(
                              (productID: any) => productID !== item._id
                            )
                          );
                        }else{
                           setState(
                            "frequentlyBoughtTogether",
                            [...state.frequentlyBoughtTogether , item._id]
                          );
                        }
                      }}
                      id={`add-product-btn-${index + 1}`}
                    >
                      <FontAwesomeIcon
                        icon={
                          state.frequentlyBoughtTogether.find(
                            (productID: any) => productID === item._id
                          )
                            ? faMinus
                            : faPlus
                        }
                        className="font-size-12px ml-[-2px]"
                      />
                    </div>
                  </li>
                </ul>
              ))}
            </div>
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default InventoryFrequenltyBoughtTab;
